import styled, {css} from 'styled-components';

import {Text} from '~atoms/Text';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const SliderWrapper = styled.div`
    flex-grow: 1;
    position: relative;
    margin: 0 8px;
`;

const thumb = css`
    background-color: black;
    cursor: pointer;
    --size: 9px;
    height: var(--size);
    width: var(--size);
    border: 2px solid white;
    border-radius: 50%;
    margin-bottom: 2.5px;
    pointer-events: all;
    position: relative;
`;

export const Input = styled.input`
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 100%;
    outline: none;
    z-index: 3;

    &,
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        -webkit-tap-highlight-color: transparent;
    }

    &::-webkit-slider-thumb {
        ${thumb}
    }

    &::-moz-range-thumb {
        ${thumb}
    }
`;

export const Slider = styled.div`
    position: relative;
    width: 100%;
`;

export const Track = styled.div`
    position: absolute;
    height: 1px;
    background: hsl(0, 0%, 90%);
    width: 100%;
    z-index: 1;
`;

export const ValueText = styled(Text)`
    width: 34px;
    overflow: visible;
    white-space: nowrap;
`;
